export interface NovaLayout {
  blobHeight: string;
  blobTop: string;
  blobWidth: string;
  bodyFontSize: number;
  bodyLineHeight: number;
  bodyTop: string;
  bodyWidth: string;
  frameHeight: string;
  framePadding?: string;
  frameWidth: string;
  iconArtworkHeight: number;
  iconArtworkLeft: number;
  iconArtworkTop: number;
  iconArtworkWidth: number;
  iconFrameSize: number;
  iconTop: string;
  innerHeight: string;
  innerWidth: string;
  titleFontWeight: number;
  titleTop: string;
  titleWidth: string;
}

export const NOVA_DESKTOP_LAYOUT: NovaLayout = {
  blobHeight: '202px',
  blobTop: '36px',
  blobWidth: '309px',
  bodyFontSize: 14,
  bodyLineHeight: 20,
  bodyTop: '158px',
  bodyWidth: '360px',
  frameHeight: '268px',
  frameWidth: '369px',
  iconArtworkHeight: 103,
  iconArtworkLeft: 5,
  iconArtworkTop: 6,
  iconArtworkWidth: 103,
  iconFrameSize: 111,
  iconTop: '13px',
  innerHeight: '268px',
  innerWidth: '369px',
  titleFontWeight: 600,
  titleTop: '124px',
  titleWidth: '369px',
};

export const NOVA_MOBILE_LAYOUT: NovaLayout = {
  blobHeight: '155.8px',
  blobTop: '11px',
  blobWidth: '93.84%',
  bodyFontSize: 12,
  bodyLineHeight: 16,
  bodyTop: '106px',
  bodyWidth: 'min(98.6%, 236px)',
  frameHeight: '218px',
  framePadding: '20px',
  frameWidth: 'min(calc(100% - 40px), 279.25px)',
  iconArtworkHeight: 69.6,
  iconArtworkLeft: 3.38,
  iconArtworkTop: 4.06,
  iconArtworkWidth: 69.6,
  iconFrameSize: 75,
  iconTop: '-11px',
  innerHeight: '178px',
  innerWidth: '100%',
  titleFontWeight: 400,
  titleTop: '72px',
  titleWidth: 'min(95.3%, 228px)',
};
